import type { InjectionKey } from 'vue';

import { inject } from 'vue';

import type { useBookingWidget } from '@/composables/booking/useBookingWidget';
import type { CartsTransactionsApi } from '@/services/booking/cartsTransactionsApi';

import type { ProductDTO } from './products';

export type BookingWidgetContext = {
  bookingWidget: ReturnType<typeof useBookingWidget>;
  cartsTransactionsApi: CartsTransactionsApi;
  activityDetails: ProductDTO | undefined;
  nextSession?: {
    availabilityType: 'STARTING_TIME' | 'OPENING_HOURS';
    date: number;
    duration: number;
    productId: string;
  };
};

export const BookingWidgetContextKey: InjectionKey<BookingWidgetContext> = Symbol('BookingWidgetContext');

export function useBookingWidgetContext() {
  const context = inject(BookingWidgetContextKey);
  if (!context) {
    throw new Error('useBookingWidgetContext must be used within a BookingWidget provider');
  }
  return context;
}
